import React from 'react';
import ReactModal from 'react-modal';

import { WindowProxy } from '@sm360/widget-commons-core-services';

import ModalService from 'commons-general/services/ModalService/ModalService.js';
import UtilsService from 'commons-general/services/UtilsService/UtilsService.js';

/* eslint no-underscore-dangle:0, react/prop-types:0 */

// TODO: #deprecated

/**
 * HOF returning an HOC
 *
 * WARNING add closeTimeoutMS to have smoother closing effects. This will only be done when
 * release 1.6.6 of react-modal is available. (https://github.com/reactjs/react-modal/issues/17);
 * @deprecated since 1.8.1, use general/components/Modal/Modal.jsx instead
 */
function withModal(name) {
    const _modal = ModalService.get(name);

    return (WrappedComponent) => {
        const displayName = UtilsService.getComponentDisplayName(WrappedComponent);

        class WithModal extends React.Component {
            constructor(props, context) {
                super(props, context);

                this.modal = _modal;

                this.callbacks = {
                    onChange: this.handleChange.bind(this),
                };

                this.state = {
                    modalIsOpen: this.modal.isOpen(),
                };
            }

            componentWillMount() {
                if (typeof window !== 'undefined') {
                    ReactModal.setAppElement('body');
                }
            }

            componentDidMount() {
                this.modal.addCallbacks(this.callbacks);
            }

            componentWillUnmount() {
                this.modal.removeCallbacks(this.callbacks);
            }

            getModalParent() {
                const windowProxy = WindowProxy.get();
                if (windowProxy) {
                    const parent = windowProxy.document.getElementsByClassName('widget-sr');
                    if (parent && parent.length) {
                        return parent[0];
                    }

                    // eslint-disable-next-line no-console
                    console.error(new Error(`withModal(${name}) Modal parent must be ".widget-sr"`));
                    return windowProxy.document.getElementsByTagName('body')[0];
                }

                return null;
            }

            handleChange() {
                this.setState({
                    modalIsOpen: this.modal.isOpen(),
                });
            }

            render() {
                const { modal, ...props } = this.props;
                let {
                    contentLabel,
                    onRequestClose,
                    isOpen,
                    // eslint-disable-next-line prefer-const
                    ...modalOptions
                } = modal;
                contentLabel = contentLabel || name;
                onRequestClose = this.modal.close;
                isOpen = this.state.modalIsOpen;
                const customStyles = {
                    content: {
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        marginRight: '-50%',
                        transform: 'translate(-50%, -50%)',
                        height: '70vh',
                    },
                };

                return (
                    <ReactModal
                        isOpen={isOpen}
                        onRequestClose={onRequestClose}
                        contentLabel={contentLabel}
                        parentSelector={this.getModalParent}
                        style={customStyles}
                        {...modalOptions}
                    >
                        <WrappedComponent modal={this.modal} {...props} />
                    </ReactModal>
                );
            }
        }

        WithModal.displayName = `WithModal(${displayName})`;

        return WithModal;
    };
}

export default withModal;
